import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M18.75 2.5a.75.75 0 0 0-1.5 0V21a.75.75 0 0 0 1.5 0V2.5ZM8.213 19.312a1.391 1.391 0 0 0 1.521-.306l6.027-6.018a1.397 1.397 0 0 0 0-1.962L9.734 5a1.353 1.353 0 0 0-1.512-.306c-.526.22-.86.717-.87 1.282V18.03c0 .564.344 1.062.86 1.282Z" }, null, -1), a = [
  n
];
function r(s, l) {
  return e(), t("svg", c, [...a]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
